import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Card } from '@/components/ui/Card';
import { Spinner } from '@/components/ui/Spinner';
import { Badge } from '@/components/ui/Badge';
import { useActiveLease } from '@/hooks/useLeases';
import { usePayments } from '@/hooks/usePayments';
import { formatCurrency, formatDate } from '@/utils/format';

export function PaymentsPage() {
  const { t } = useTranslation();
  const { activeLease } = useActiveLease();
  const payments = usePayments(activeLease ? { lease_id: activeLease.id } : {});

  if (payments.isLoading) return <Spinner />;

  return (
    <Card title={t('payments.history')}>
      <table className="w-full text-left text-sm">
        <thead className="text-xs uppercase text-slate-500">
          <tr>
            <th className="py-2">{t('payments.period')}</th>
            <th>{t('payments.amount')}</th>
            <th>{t('payments.due_by')}</th>
            <th>{t('common.status')}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {payments.data?.data.map((p) => (
            <tr key={p.id} className="border-t border-slate-100">
              <td className="py-2">
                {p.period_month}/{p.period_year}
              </td>
              <td>{formatCurrency(p.amount_expected)}</td>
              <td>{formatDate(p.due_date)}</td>
              <td>
                <Badge
                  tone={
                    p.status === 'paid'
                      ? 'success'
                      : p.status === 'overdue'
                        ? 'danger'
                        : 'info'
                  }
                >
                  {t(`payments.status.${p.status}`)}
                </Badge>
              </td>
              <td>
                <Link to={`/payments/${p.id}`} className="text-brand hover:underline">
                  {t('common.view')}
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {(!payments.data || payments.data.data.length === 0) && (
        <p className="py-6 text-center text-sm text-slate-500">{t('web.empty.no_data')}</p>
      )}
    </Card>
  );
}
